export const OFFER_CHAT_BOT_TRIGGER = "offerChatBotTrigger";
export const OFFER_CHAT_BOT_TRIGGER = "offerChatBotTrigger";
